import Cookies from "js-cookie";
import { forgetSignIn } from "./idleSession";

// Browsers only delete a cookie when name+domain+path match. The
// session cookies are set by the API with Domain=whgdocs.com (and
// older sessions carry other scopes), so removing them with the
// page hostname alone deletes nothing and Sign out bounces straight
// back into the session (live production bug 2026-07-16). Remove
// every scope variant JS can see: host-only, the page host, and
// each parent domain with and without the leading dot.
export function clearAuthCookies() {
  const hostname = globalThis.location.hostname;
  const domains = [null, hostname, `.${hostname}`];
  const parts = hostname.split(".");
  for (let i = 1; i < parts.length - 1; i += 1) {
    const parent = parts.slice(i).join(".");
    domains.push(parent, `.${parent}`);
  }
  const names = ["access_token", "refresh_token", "user_info", "signin_sid", "csrftoken"];
  for (const name of names) {
    Cookies.remove(name);
    for (const domain of domains) {
      Cookies.remove(name, domain ? { path: "/", domain } : { path: "/" });
    }
  }
  localStorage.removeItem("user_id");
  forgetSignIn();
}
